// extracted by mini-css-extract-plugin
export default {"view":"CreateProjectView_view__RY0d7","form":"CreateProjectView_form__aCSkQ"};